// export const apiEndpoint = 'https://ais-backend.tuxy.broers.me'
// export const token = '123454321ABC'

export const apiEndpoint = 'https://ws.aisaviationgroup.com'
export const token = 'kWG9V1vPx6'
export const multipleLanguages = true
export const defaultLanguage = 'nl'
export const useGoogleAnalytics = true
export const googleAnalyticsId = 'UA-62727525-1'
export const useGoogleMaps = true
export const googleMapsApiKey = 'AIzaSyBGVnJa9_72wHJqdPxCf19G2TvrfCdZIhI'
export const hasGraduates = true
